export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const NAVBAR_WIDTH = 260
export const MINUTES = 5
export const EVENT_CODES = {
  UNAUTH_USER: "UNAUTH_USER"
}
export const MESSAGES = {
  UNAUTH_USER: "You do not have access for this app"
}